import { useTranslation } from "react-i18next";
import classes from "./Loader.module.css";

export const LOADER_SIZES = Object.freeze({
  XSMALL: "x-small",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
});

const Loader = ({ fullHeight = false, size, withoutText = false }) => {
  const { t } = useTranslation("general");

  const sizeClass =
    size === LOADER_SIZES.XSMALL
      ? classes["x-small"]
      : size === LOADER_SIZES.SMALL
      ? classes.small
      : size === LOADER_SIZES.MEDIUM
      ? classes.medium
      : "";

  return (
    <div
      className={`${classes.loader} ${
        fullHeight ? classes.fullScreenHeight : ""
      } ${sizeClass}`}
    >
      {!withoutText && <p className={classes.loaderText}>{t("loading")}</p>}
    </div>
  );
};

export default Loader;
